var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4961 7.50293C14.4961 11.249 11.4336 14.2842 7.71484 14.2842C3.96875 14.2842 0.933594 11.249 0.933594 7.50293C0.933594 3.78418 3.96875 0.72168 7.71484 0.72168C11.4336 0.72168 14.4961 3.78418 14.4961 7.50293ZM6.92188 11.1123L11.9531 6.08105C12.1172 5.91699 12.1172 5.61621 11.9531 5.45215L11.3242 4.85059C11.1602 4.65918 10.8867 4.65918 10.7227 4.85059L6.62109 8.95215L4.67969 7.03809C4.51562 6.84668 4.24219 6.84668 4.07812 7.03809L3.44922 7.63965C3.28516 7.80371 3.28516 8.10449 3.44922 8.26855L6.29297 11.1123C6.45703 11.2764 6.75781 11.2764 6.92188 11.1123Z",
    fill: "#04AC61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSuccessIcon);
export default __webpack_public_path__ + "static/media/check-success-icon.14b16b2eb8e724b89b3e893c65803f1f.svg";
export { ForwardRef as ReactComponent };